<template>
	<div v-if="imageComponentName" class="user-badge flex-center flex-bottom">
		<component :is="imageComponentName" class="actual badge-svg" :style="style" />
		<Tooltip v-if="tooltip" arrow="top center">
			<p>{{ tooltipContent }}</p>
		</Tooltip>
	</div>
</template>

<script>
import { toFiniteNumber, toString } from '@/helpers/convert';

export default {
  name: 'Badge',
  props: {
    badge: Object,
    tooltip: {
      type: [Boolean, String],
      default: false,
    },
    size: {
      default: 32,
    },
  },
  computed: {
    /**
     * @returns {boolean}
     */
    hasTooltip() {
      return this.tooltip;
    },
	tooltipContent() {
		if (this.tooltip == 'criteriaForEarningBadgeOnShooterSide') {
			return this.badge.criteriaForEarningBadgeOnShooterSide;
		} else {
			return this.badge.name;
		}
	},
    /**
     * @returns {string | null}
     */
    imageComponentName() {
      const { keyword } = this;
      if (!keyword) {
        return null;
      }
      const registeredComponents = this.$options?.components;
      if (!registeredComponents) {
        return null;
      }
      const componentName = `Badge${keyword}`;
      return componentName in registeredComponents ? componentName : null;
    },
    /**
     * @returns {string}
     */
    keyword() {
      return toString(this.badge?.keyword) || '';
    },
    /**
     * @returns {string}
     */
    name() {
      return toString(this.badge?.name) || '';
    },
    /**
     * @returns {string | null}
     */
    style() {
      const size = toFiniteNumber(this.size, 1);
      return size ? `max-width: ${size}px; max-height: ${size}px;` : null;
    },
  },
};
</script>
